<template>
	<div v-if="url !== undefined && url !== null && url !== false && url !== ''" class="w5-preview-image-wrapper">
		<!-- сама картинка -->
		<img :src="currentUrl"			
			:class="{ 'ready-image': imageReady, 'cursor-pointer-default': noPreview }"
			:title="text ? text : '' | ftc"
			@click="showPreviewDialog"
			class="w5-view-field-preview-image"
			ref="image"
			/>

		<!-- диалог просмотра -->
		<transition name="modal">
			<div v-show="showModal" @click="hideModalDialog" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop :style="'width:' + modalWidth + 'px;'">

						<!-- заголовок -->
						<div class="modal-header">
							<span>{{ text ? text : '' | ftc }}</span>
							<button type="button" class="close" @click="hideModalDialog">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<img ref="imageInDialog" :style="'width:' + imageWidth + 'px; height:' + imageHeight + 'px;'" />
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<div class="w5-preview-in-dialog-text">{{ title ? title : '' | ftc }}</div>
							<span style="float: left">{{ size ? '(' + size + ')' : '' | ftc }}</span>
							<a class="btn btn-submit w5-file-uploader-load-button pull-right" :href="url">{{ 'main/download' | ftc }}</a>
						</div>
					</div>
				</div>
			</div>
		</transition>

	</div>
</template>

<script>
import { EventBus } from '@/bus.js'
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'previewImageComponent',
	//=========================================================================
	// неизменяемые свойства компонента
	//=========================================================================
	props: ['url', 'title', 'text', 'size', 'noPreview'],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			currentUrl: '/static/img/loading32.gif',
			imageReady: false,
			imageWidth: 0,
			imageHeight: 0,
			modalWidth: 0,

			showModal: false
		}
	},
	//=========================================================================
	// компонент создан
	//=========================================================================
	created() {
		let image = new Image()
		image.src = this.url

		// конец загрузки картинки
		image.onload = () => {
			// просто поменяем источник - браузер сам возьмет картинку из кеша
			this.$refs['image'].src = image.src
			this.$refs['imageInDialog'].src = image.src

			// рассчитаем сразу размеры
			this.imageWidth = image.naturalWidth
			this.imageHeight = image.naturalHeight
			// текущая ширина окна
			let windowWidth = this.$store.state.windowWidth
			let windowHeight = this.$store.state.windowHeight

			// максимальные размеры
			let _delta = 40

			if (windowWidth <= 420)
			{
				_delta = 20
			}
			if (windowWidth > 420 && windowWidth <= 767)
			{
				_delta = 30
			}
			if (windowWidth > 767 && windowWidth <= 900)
			{
				_delta = 40
			}
			else _delta = 60

			let maxWidth = windowWidth - _delta
			let maxHeight = windowHeight - 190
			if (maxWidth < 100) maxWidth = 100
			if (maxHeight < 100) maxHeight = 100

			// пропорционально уменьшаем
			if (this.imageWidth > maxWidth || this.imageHeight > maxHeight)
			{
				let _k = 1
				if (this.imageWidth > this.imageHeight) _k = maxWidth / this.imageWidth
				else _k = maxHeight / this.imageHeight

				this.imageWidth = parseInt(this.imageWidth * _k)
				this.imageHeight = parseInt(this.imageHeight * _k)

				// дополнительная проверка на высоту
				if (this.imageHeight > maxHeight)
				{
					_k = maxHeight / this.imageHeight
					this.imageWidth = parseInt(this.imageWidth * _k)
					this.imageHeight = parseInt(this.imageHeight * _k)
				}
			}

			this.modalWidth = this.imageWidth + 30
			if (this.modalWidth < 200) this.modalWidth = 200

			this.imageReady = true
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		this.$nextTick(function() {
			// навешиваем обработчик на нажатие клавиш
			document.addEventListener('keydown', this.keyDownHandler)
		})
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler)
	},
	//=========================================================================
	// методы
	//=========================================================================
	methods: {
		keyDownHandler(e) {
			if (this.showModal && e.keyCode === 27)
			{
				this.hideModalDialog()
			}
		},
		showPreviewDialog() {
			if (this.noPreview) return
			EventBus.$emit('w5-body-scroll-disable')
			this.showModal = true
		},
		hideModalDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showModal = false
			this.hideModalMask()
		}
	}

	//=========================================================================
}
</script>

<style scoped>
.w5-preview-image-wrapper {

}

.w5-view-field-preview-image {
	display: block;
	max-width: 100%;	
	margin: 10px 0;
	border-radius: 4px;
}

.ready-image {
	cursor: pointer;
}

.w5-file-uploader-load-button {
	font-size: 11px;
	height: 24px;
	line-height: 24px;
	padding: 0 6px;
}

</style>



// WEBPACK FOOTER //
// previewimg.vue?443e19e4